// src/containers/Receptions/ReceptionList/components/ReceptionListTable.tsx
import React from "react";
import JTable from "$components/JTable/JTable";
import { IReceptionListTableProps } from "../types";
import useAuth from "$hooks/useAuth";

const ReceptionListTable: React.FC<IReceptionListTableProps> = ({
  columns,
  receptions,
  isFetching,
  pageCount,
  filters,
  setFilter,
  setPageIndex,
  pageIndex,
  renderRowSubComponent,
  setSelectedRowsReception,
  selectedRowsReception,
}) => {
  const { isAdmin } = useAuth();

  return (
    <JTable
      data={receptions ?? []}
      columns={columns}
      isFetching={isFetching}
      renderRowSubComponent={renderRowSubComponent}
      pageCount={pageCount}
      filters={filters}
      setFilter={setFilter}
      setPageIndex={setPageIndex}
      pageIndex={pageIndex}
      setSelectedRows={setSelectedRowsReception}
      selectedRows={selectedRowsReception}
      hasActionRow={isAdmin()}
      pageName="receptionList"
      noDataText="Aucune réception n'a encore été créée"
    />
  );
};

// Memoize the component to prevent unnecessary re-renders when props haven't changed
export default React.memo(ReceptionListTable);
